import Global from '../../../../global';

export default () => {
  const env = Global.config.environment;
  const config = require(`./content.${env}.js`).default;
  return config;
};
